import { render, staticRenderFns } from "./BaseCreateForm.vue?vue&type=template&id=ef39daa0&"
import script from "./BaseCreateForm.vue?vue&type=script&lang=js&"
export * from "./BaseCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports